import defaultSettings from '@/settings'

const title = defaultSettings.title || 'Spring Boot Plus Vue'


export default function getPageTitle() {
  // if (pageTitle) {
  //   return `${pageTitle} - ${title}`
  // }
  return `${title}`
}
